<template>
    <v-app :class="{'global-style': $myStore.state.largeFont}">
        <div v-if="$myStore.state.loaderCount > 0" class="loader">
            <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        </div>

        <v-dialog v-model="alertModal.show" max-width="480">
            <v-card>
                <v-card-title></v-card-title>
                <v-card-text class="grey--text text--darken-2" v-html="alertModal.text"> </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="alertModal.show = false">{{ $t('buttons.ok') }} </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="verifyModal.show" max-width="480" persistent>
            <v-card class="pa-4">
                <v-card-text class="grey--text text--darken-2" v-html="verifyModal.text"> </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="verifyModal.result(true)">{{ $t('buttons.yes') }} </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="verifyModal.result(false)">{{ $t('buttons.no') }} </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="promptModal.show" max-width="480" persistent>
            <v-card class="pa-4">
                <v-card-text class="grey--text text--darken-2">
                    <InputField v-model="promptModal.value" :label="promptModal.text"></InputField>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="promptModal.result(true)">{{ $t('buttons.ok') }} </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="promptModal.result(false)">{{ $t('buttons.cancel') }} </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
            v-model="notification.show"
            :timeout="3000"
            :top="true"
            class="notification black--text text-center"
            color="primary"
            >{{ notification.text }}
        </v-snackbar>

        <template v-if="$myStore.state.loggedIn">
            <v-app-bar app clipped-left dark dense flat>
                <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
                <span style="font-size: larger; color: azure">AZARA CRM</span>
                <v-breadcrumbs :items="$myStore.state.breadcrumbs" divider=">" large></v-breadcrumbs>
                <v-spacer></v-spacer>
                <span v-if="$myStore.state.user" class="mr-3">
                    {{ $myStore.state.user.first_name }} {{ $myStore.state.user.last_name }}
                </span>
                <v-tooltip bottom>
                    <template v-slot:activator="{on, attrs}">
                        <v-btn depressed icon v-bind="attrs" @click="settingsDrawer = !settingsDrawer" v-on="on">
                            <v-icon small>fas fa-cog</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t('tooltips.accessibilitySettings') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{on, attrs}">
                        <v-btn depressed icon v-bind="attrs" @click="webRegistrationsClick" v-on="on">
                            <v-icon small>fa-list-alt</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t('tooltips.webRegistrations') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{on, attrs}">
                        <v-btn depressed icon v-bind="attrs" @click="logoutClick" v-on="on">
                            <v-icon small>fa-sign-out-alt</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t('tooltips.logout') }}</span>
                </v-tooltip>
            </v-app-bar>
            <v-navigation-drawer v-model="drawer" app clipped dark >
                <v-list dense class="max-v-list-height">
                    <v-list-item
                        :to="{
                            path: '/dashboard',
                        }"
                    >
                        <v-list-item-icon>
                            <v-icon>fas fa-tachometer-alt</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t('modules.dashboard') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        :to="{
                            path: '/seafarers',
                        }"
                    >
                        <v-list-item-icon>
                            <v-icon>far fa-user-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t('modules.seafarer') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        :to="{
                            path: '/vacancies',
                        }"
                    >
                        <v-list-item-icon>
                            <v-icon>far fa-compass</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t('modules.vacancy') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        :to="{
                            path: '/applications',
                        }"
                    >
                        <v-list-item-icon>
                            <v-icon>far fa-question-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t('modules.application') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        :to="{
                            path: '/placements',
                        }"
                    >
                        <v-list-item-icon>
                            <v-icon>far fa-check-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t('modules.placement') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        :to="{
                            path: '/crew-list',
                        }"
                    >
                        <v-list-item-icon>
                            <v-icon>far fa-list-alt</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t('modules.crewList') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        v-if="$myStore.state.user.user_role_id != 3"
                        :to="{
                            path: '/entities',
                        }"
                    >
                        <v-list-item-icon>
                            <v-icon>far fa-handshake</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t('modules.entity') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        :to="{
                            path: '/maritime-objects',
                        }"
                    >
                        <v-list-item-icon>
                            <v-icon>fas fa-ship</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t('modules.maritimeObject') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        :to="{
                            path: '/contracts',
                        }"
                    >
                        <v-list-item-icon>
                            <v-icon>fas fa-file-signature</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t('modules.contract') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-group>
                        <template v-slot:activator>
                            <v-list-item-icon>
                                <v-icon>fas fa-landmark</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('modules.finances') }}</v-list-item-title>
                        </template>
                        <v-list-item
                            :to="{
                                path: '/payslips',
                            }"
                            class="pl-10"
                        >
                            <v-list-item-icon>
                                <v-icon>fas fa-tag</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('modules.payroll') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="$myStore.state.user.user_role_id == 1"
                            :to="{
                                path: '/billing-lists',
                            }"
                            class="pl-10"
                        >
                            <v-list-item-icon>
                                <v-icon>fas fa-file-signature</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('modules.billing') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="$myStore.state.user.user_role_id == 1"
                            :to="{
                                path: '/invoices',
                            }"
                            class="pl-10"
                        >
                            <v-list-item-icon>
                                <v-icon>fas fa-file-invoice</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('modules.invoicing') }}</v-list-item-title>
                        </v-list-item>
                    </v-list-group>

                    <v-list-group v-if="$myStore.state.user.user_role_id != 3">
                        <template v-slot:activator>
                            <v-list-item-icon>
                                <v-icon>fas fa-database</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('modules.databases') }}</v-list-item-title>
                        </template>
                        <v-list-item
                            :to="{
                                path: '/document-types',
                            }"
                            class="pl-10"
                        >
                            <v-list-item-icon>
                                <v-icon>far fa-address-card</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('modules.documentType') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            :to="{
                                path: '/ranks',
                            }"
                            class="pl-10"
                        >
                            <v-list-item-icon>
                                <v-icon>fas fa-anchor</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('modules.rank') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            :to="{
                                path: '/banks',
                            }"
                            class="pl-10"
                        >
                            <v-list-item-icon>
                                <v-icon>fa-money-check-alt</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('modules.banks') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            :to="{
                                path: '/airports',
                            }"
                            class="pl-10"
                        >
                            <v-list-item-icon>
                                <v-icon>fas fa-plane-departure</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('modules.airports') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            :to="{
                                path: '/internal-offices',
                            }"
                            class="pl-10"
                        >
                            <v-list-item-icon>
                                <v-icon>far fa-building</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('modules.internalOffice') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            :to="{
                                path: '/other-databases',
                            }"
                            class="pl-10"
                        >
                            <v-list-item-icon>
                                <v-icon>far fa-caret-square-down</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('modules.otherDatabases') }}</v-list-item-title>
                        </v-list-item>
                    </v-list-group>
                    <v-list-item
                        v-if="$myStore.state.user.user_role_id == 1"
                        :to="{
                            path: '/user-accounts',
                        }"
                    >
                        <v-list-item-icon>
                            <v-icon>fas fa-tools</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t('modules.userAccount') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        v-if="$myStore.state.user.user_role_id == 1"
                        :to="{
                            path: '/statistics',
                        }"
                    >
                        <v-list-item-icon>
                            <v-icon>fas fa-chart-bar</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t('modules.statistics') }}</v-list-item-title>
                    </v-list-item>
                    <!-- <v-list-item :to="{ path: '/contracts' }">
						<v-list-item-icon>
							<v-icon>fa-folder</v-icon>
						</v-list-item-icon>
						<v-list-item-title>{{
							$t("modules.contracts")
						}}</v-list-item-title>
					</v-list-item>
					<v-list-item :to="{ path: '/billing' }">
						<v-list-item-icon>
							<v-icon>fa-folder</v-icon>
						</v-list-item-icon>
						<v-list-item-title>{{
							$t("modules.billing")
						}}</v-list-item-title>
					</v-list-item>
					<v-list-item :to="{ path: '/invoices' }">
						<v-list-item-icon>
							<v-icon>fa-folder</v-icon>
						</v-list-item-icon>
						<v-list-item-title>{{
							$t("modules.invoices")
						}}</v-list-item-title>
					</v-list-item>
					<v-list-item :to="{ path: '/payrolles' }">
						<v-list-item-icon>
							<v-icon>fa-folder</v-icon>
						</v-list-item-icon>
						<v-list-item-title>{{
							$t("modules.payrolles")
						}}</v-list-item-title>
					</v-list-item>
					<v-list-item :to="{ path: '/reports' }">
						<v-list-item-icon>
							<v-icon>fa-folder</v-icon>
						</v-list-item-icon>
						<v-list-item-title>{{
							$t("modules.reports")
						}}</v-list-item-title>
					</v-list-item> -->
                    <div class="menu-footer-eu-img">
                        <img :src="publicPath + 'HR_Financira_Europska_unija_RGB_NEG.png'" width="200vh" />
                    </div>
                    <div class="menu-footer-azara-img">
                        <img :src="publicPath + 'azara_logo_color.fw.png'" width="200vh" />
                    </div>
                    <div class="menu-footer" v-html="$getSettings('FOOTER_HTML')"></div>
                </v-list>
            </v-navigation-drawer>
            <v-navigation-drawer temporary right app v-model="settingsDrawer" width="300">
                <AccessibilitySettings
                    :drawer="settingsDrawer"
                    @closeSettings="settingsDrawer = false"
                ></AccessibilitySettings>
            </v-navigation-drawer>
        </template>
        <template v-slot:activator>
            <v-btn color="blue darken-2" dark fab>
                <v-icon small>fas fa-cog</v-icon>
            </v-btn>
        </template>
        <v-main v-if="initialLoadCompleted">
            <transition name="fade">
                <router-view></router-view>
            </transition>
        </v-main>
    </v-app>
</template>

<script>
import InputField from './components/trinkets/InputField';
import AccessibilitySettings from './components/trinkets/AccessibilitySettings';
export default {
    name: 'App',
    components: {InputField, AccessibilitySettings},
    data() {
        return {
            larger_font: false,
            drawer: null,
            alertModal: {
                show: false,
                text: '',
            },
            verifyModal: {
                show: false,
                text: '',
                result: (result) => {
                    this.verifyModal.show = false;
                    this.verifyModal.reaction(result);
                },
                reaction: () => {},
            },
            promptModal: {
                show: false,
                text: '',
                value: '',
                result: (result) => {
                    this.promptModal.show = false;
                    if (result !== false) {
                        this.promptModal.reaction(this.promptModal.value);
                    } else {
                        this.promptModal.reaction(false);
                    }
                },
                reaction: () => {},
            },
            notification: {
                show: false,
                text: '',
            },
            initialLoadCompleted: false,
            breadcrumbs: [],
            publicPath: process.env.BASE_URL,
            settingsDrawer: false,
        };
    },
    computed: {},
    methods: {
        logoutClick() {
            let vm = this;
            this.$verify(this.$t('alerts.logoutQuestion'), (result) => {
                if (result) {
                    this.$APICall('post', 'logout', {}, (data, success) => {
                        if (success) {
                            vm.$myStore.commit('setUser', null);
                            vm.$myStore.commit('setLoggedIn', false);
                            vm.$router.push('/login');
                        }
                    });
                }
            });
        },
        profileClick() {
            this.$router.push('/profile');
        },
        logoClick() {
            this.$router.push('/dashboard');
        },
        webRegistrationsClick() {
            window.open(this.$getSettings('WEB_REGISTRATIONS_URL'), '_blank');
        },
        showPDF(fileName) {
            window.open(process.env.BASE_URL + fileName + '.pdf');
        },
        logoReroute() {
            this.$router.push('/dashboard');
        },
    },
    watch: {
        $route() {
            if (!this.$myStore.state.loggedIn) return;
            let vm = this;
            // Re-sync the cached user (role) from the backend on every navigation so
            // a role change made by an admin takes effect without a hard refresh.
            // showLoader = false keeps the re-sync invisible.
            this.$APICall(
                'get',
                'session',
                {},
                (data, success) => {
                    if (success && data) {
                        vm.$myStore.commit('setUser', data);
                    }
                },
                false,
            );
        },
    },
    mounted() {
        var vm = this;
        this.$vuetify.theme.themes.light.primary = '#09B3B5';
        this.$vuetify.theme.themes.light.secondary = '#F6BB14';

        this.$modalBus.$on('ALERT', (message) => {
            vm.alertModal.text = message;
            vm.alertModal.show = true;
        });
        this.$modalBus.$on('VERIFY', (data) => {
            vm.verifyModal.text = data.message;
            vm.verifyModal.reaction = data.response;
            vm.verifyModal.show = true;
        });
        this.$modalBus.$on('PROMPT', (data) => {
            vm.promptModal.text = data.message;
            vm.promptModal.value = data.initial;
            vm.promptModal.reaction = data.response;
            vm.promptModal.show = true;
        });
        this.$modalBus.$on('NOTIFY', (message) => {
            vm.notification.text = message;
            vm.notification.show = true;
        });

        this.$APICall('get', 'session', {}, (data, success) => {
            if (success) {
                vm.$myStore.commit('setUser', data);
                vm.$myStore.commit('setLoggedIn', true);
                let baseRoutes = ['login', null];
                if (baseRoutes.indexOf(vm.$router.currentRoute.name) !== -1) {
                    vm.$router.push('placements');
                }
                vm.initialLoadCompleted = true;
                if (data.version != vm.$getCookie('ide3_version')) {
                    vm.$setCookie('ide3_version', data.version, 30);
                    window.location.reload(true);
                }
            } else {
                vm.$APICall('get', 'version', {}, (data, success) => {
                    if (success) {
                        if (data.version != vm.$getCookie('ide3_version')) {
                            vm.$setCookie('ide3_version', data.version, 30);
                            window.location.reload(true);
                        }
                        vm.$myStore.commit('setUser', null);
                        vm.$myStore.commit('setLargeFont', data.large_font);
                        vm.$myStore.commit('setLoggedIn', false);
                        vm.$router.replace('/login');
                        vm.initialLoadCompleted = true;
                    }
                });
            }
        });
    },
};
</script>

<style scoped>
>>> .max-v-list-height {
    max-height: calc(100vh - 260px);
    overflow-y: auto;
}

.v-btn--example {
    bottom: 0;
    position: absolute;
    margin: 0 0 16px 16px;
}
.notification {
    z-index: 999999;
}

.loader {
    position: fixed;
    left: 0px;
    top: 0px;
    z-index: 999;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    font-size: 100px;
    text-align: center;
    padding-top: 100px;
}

.fade-enter {
    opacity: 0;
}

.fade-enter-active {
    transition: opacity 1s;
}

.fade-to {
    opacity: 1;
}

>>> .cursor-pointer {
    cursor: pointer;
}

/* >>> .v-main {
    background-color: #ffffff;
} */

.menu-footer-eu-img {
    position: fixed;
    bottom: 40px;
    width: 100%;
    text-align: center;
}

.menu-footer-azara-img {
    position: fixed;
    bottom: 100px;
    width: 100%;
    text-align: center;
}

.menu-footer {
    position: fixed;
    bottom: 10px;
    width: 100%;
    text-align: center;
}

>>> .menu-footer a {
    text-decoration: none;
}

>>> .action-bar {
    position: fixed;
    bottom: 0;
    left: 1;
    width: 100%;
    z-index: 9;
    background-color: #efefef;
    text-align: center;
    -webkit-box-shadow: 0px -1px 5px -1px rgba(163, 163, 163, 1);
    -moz-box-shadow: 0px -1px 5px -1px rgba(163, 163, 163, 1);
    box-shadow: 0px -1px 5px -1px rgba(163, 163, 163, 1);
}

.global-style .v-input {
    font-size: 54px;
}

.global-style .v-label {
    font-size: 27px;
    height: 100%;
}

.global-style .v-btn,
.global-style .v-tab,
.global-style .v-card__text,
.global-style .v-data-table {
    font-size: 1.1rem;
}

.global-style .v-card__title {
    font-size: 1.5rem;
}

.global-style .v-breadcrumbs li {
    font-size: 18px;
}

.global-style .text-subtitle-1,
.global-style .text-body-1 {
    font-size: 1.2rem !important;
}

.global-style .navigation-items .v-list-item .v-list-item__title {
    font-size: 1rem !important;
    height: 100%;
}

.global-style .v-list-item__title,
.global-style .subtitle-1 {
    font-size: 1.2rem !important;
}

.global-style .text-h6 {
    font-size: 1.45rem !important;
}

.global-style .text-h5 {
    font-size: 1.7rem !important;
}

.global-style .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 1.1rem;
}

.global-style .v-calendar .v-event-timed {
    font-size: 16px;
}

.global-style .v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child),
.v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child),
.v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 0px;
}

.global-style .menu-footer {
    font-size: 18px;
}
</style>
